<template>
	<v-row v-if="!loading" class="ma-0 pb-offset">
		<v-col class="pa-0">

			<show v-if="models.compliancerisk" :id="id" :models="models" :infos="infos" topClass=""></show>

			<!-- Valutazione rischio -->
			<v-card v-if="risk" class="background-2 round-card mt-4">
				<v-card-title class="pa-3"><p class="pl-2 pl-xl-3 mb-0">Valutazione del rischio</p></v-card-title>
				<v-divider></v-divider>
				<v-card-text class="pa-4">
					<v-row>
						<v-col cols="6" md="3">
							<div class="grey--text">Probabilità × Impatto</div>
							<div class="text-h6">{{ risk.probability || '–' }} × {{ risk.impact || '–' }}</div>
						</v-col>
						<v-col cols="6" md="3">
							<div class="grey--text">Punteggio</div>
							<div class="text-h6">{{ risk.score != null ? risk.score : '–' }}</div>
						</v-col>
						<v-col cols="6" md="3">
							<div class="grey--text">Livello</div>
							<v-chip v-if="risk.level" :color="levelColor(risk.level)" dark label>{{ levelLabel(risk.level) }}</v-chip>
							<span v-else>–</span>
						</v-col>
						<v-col cols="6" md="3">
							<div class="grey--text">Rischio residuo</div>
							<v-chip v-if="risk.residual_level" :color="levelColor(risk.residual_level)" dark label outlined>
								{{ levelLabel(risk.residual_level) }} ({{ risk.residual_score }})
							</v-chip>
							<span v-else>–</span>
						</v-col>
					</v-row>
					<div v-if="risk.compliance_treatment_text" class="mt-3">
						<span class="grey--text mr-2">Trattamento:</span>{{ risk.compliance_treatment_text }}
					</div>
					<div v-if="risk.asset" class="mt-1"><span class="grey--text mr-2">Asset:</span>{{ risk.asset }}</div>
				</v-card-text>
			</v-card>

			<!-- Norme -->
			<v-card v-if="risk" class="background-2 round-card mt-4">
				<v-card-title class="pa-3">
					<p class="pl-2 pl-xl-3 mb-0">Norme</p>
					<v-spacer></v-spacer>
					<v-btn text color="primary" small @click="openNorms"><v-icon left small>mdi-pencil</v-icon> Modifica</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="pa-4">
					<template v-if="risk.norms && risk.norms.length">
						<v-chip v-for="n in risk.norms" :key="n.value" :color="n.color || 'primary'" dark small class="mr-1" label>{{ n.text }}</v-chip>
					</template>
					<span v-else class="grey--text">— nessuna —</span>
				</v-card-text>
			</v-card>

			<dms-uploader class="mt-4" :id="id" attachable-type="compliancerisk"></dms-uploader>

			<v-tooltip top>
				<template v-slot:activator="{ on: tooltip }">
					<v-fab-transition>
						<v-btn v-on="{ ...tooltip }" @click.native="$eventBusUtility.goTo($router, 'compliancerisks-edit', id)" color="primary" dark fixed bottom right fab>
							<v-icon>edit</v-icon>
						</v-btn>
					</v-fab-transition>
				</template>
				<span>Modifica</span>
			</v-tooltip>

			<v-dialog v-model="normsDialog" max-width="560" persistent>
				<v-card class="background-2 round-card">
					<v-card-title class="pa-3"><p class="pl-2 pl-xl-3 mb-0">Norme applicabili</p></v-card-title>
					<v-divider></v-divider>
					<v-card-text class="pa-4">
						<v-autocomplete v-model="formNorms" :items="normOptions" item-text="text" item-value="value"
							label="Norme" outlined dense :menu-props="{'offset-y': true}" multiple chips small-chips deletable-chips prepend-icon="mdi-certificate"></v-autocomplete>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions class="pa-3">
						<v-spacer></v-spacer>
						<v-btn text color="info" @click="normsDialog = false">Annulla</v-btn>
						<v-btn text color="primary" :loading="saving" @click="saveNorms">Salva</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

		</v-col>
	</v-row>
</template>

<script>
export default {
	name: 'ComplianceRisk',
	props: { id: Number },
	data() {
		return {
			loading: true,
			models: {},
			infos: {},
			normsDialog: false,
			saving: false,
			formNorms: [],
			normOptions: []
		}
	},
	computed: {
		risk() { return this.models.compliancerisk }
	},
	created() { this.load() },
	methods: {
		load() {
			this.loading = true
			this.axios.get('compliancerisks/' + this.id).then(r => {
				this.models = r.data.models
				this.infos = r.data.infos
				this.loading = false
			}, () => { this.loading = false; this.$store.commit('setSnackbarError') })
		},
		levelColor(level) {
			return { basso: '#4caf50', medio: '#ff9800', alto: '#ff5722', critico: '#f44336' }[level] || 'grey'
		},
		levelLabel(level) {
			return { basso: 'Basso', medio: 'Medio', alto: 'Alto', critico: 'Critico' }[level] || level
		},
		openNorms() {
			this.formNorms = (this.risk.norms || []).map(n => n.value)
			if (!this.normOptions.length) this.axios.get('compliance-norms-options').then(r => { this.normOptions = r.data.data })
			this.normsDialog = true
		},
		saveNorms() {
			this.saving = true
			this.axios.put('compliancerisks/' + this.id, { norms: this.formNorms }).then(() => {
				this.saving = false; this.normsDialog = false
				this.$store.commit('setSnackbar', { value: true, color: 'success', text: 'Salvato', timeout: 4000 })
				this.load()
			}, () => { this.saving = false; this.$store.commit('setSnackbarError') })
		}
	}
}
</script>
